import { Routes } from '@angular/router';
import { authGuard, authPagesGuard } from './guards/auth.guard';
import { ProfileGuard } from './guards/profile.guard';
import { HomeComponent } from './pages/home/home.component';
import { FaqsComponent } from './pages/others/faqs/faqs.component';
import { NotFoundComponent } from './pages/others/not-found/not-found.component';
import { StaticContentComponent } from './pages/others/static-content/static-content.component';
import { ContentLayoutComponent } from './shared/layout-components/layout/content-layout/content-layout.component';
import { HomeResolver } from './shared/services/home.resolver';

export const routes: Routes = [
  {
    path: 'auth',
    canActivate: [authPagesGuard],
    loadChildren: () => import('./pages/authentication/authentication.routes').then((routes) => routes.routes),
  },
  {
    path: 'profile',
    canActivate: [ProfileGuard],
    loadChildren: () => import('./pages/profile/profile.routes').then((routes) => routes.routes),
  },
  {
    path: 'my',
    canActivate: [authGuard],
    loadChildren: () => import('./pages/my/my.routes').then((routes) => routes.routes),
  },
  {
    path: 'sports',
    loadChildren: () => import('./pages/sports/sports.routes').then((routes) => routes.routes),
    data: { breadcrumb: 'Sports' },
  },
  {
    path: 'events',
    // canActivate: [authGuard],
    loadChildren: () => import('./pages/events/events.routes').then((routes) => routes.routes),
    data: { breadcrumb: 'Events' },
  },
  {
    path: 'feed',
    canActivate: [authGuard],
    loadChildren: () => import('./pages/feed/feed.routes').then((routes) => routes.routes),
    data: { breadcrumb: 'Feed' },
  },
  {
    path: 'media',
    loadChildren: () => import('./pages/media/news.routes').then((routes) => routes.routes),
    data: { breadcrumb: 'Media' },
  },
  {
    path: 'interview',
    loadChildren: () => import('./pages/interview/interview.routes').then((routes) => routes.routes),
    data: { breadcrumb: 'Interview' },
  },
  {
    path: 'store',
    loadChildren: () => import('./pages/store/store.routes').then((routes) => routes.routes),
    data: { breadcrumb: 'Store' },
  },
  {
    path: 'leaderboard',
    component: ContentLayoutComponent,
    children: [
      { path: '', loadComponent: () => import('./pages/leaderboard/leaderboard.component').then((m) => m.LeaderboardComponent), pathMatch: 'full' },
    ],
    data: { breadcrumb: 'Leaderboard' },
  },
  {
    path: '',
    component: ContentLayoutComponent,
    children: [
      { path: '', component: HomeComponent, pathMatch: 'full', resolve: { data: HomeResolver } },
      { path: 'about-us', component: StaticContentComponent, pathMatch: 'full', data: { breadcrumb: 'About Us' } },
      { path: 'what-we-offer', component: StaticContentComponent, pathMatch: 'full', data: { breadcrumb: 'What We Offer' } },
      { path: 'privacy-policy', component: StaticContentComponent, pathMatch: 'full', data: { breadcrumb: 'Privacy Policy' } },
      { path: 'terms-conditions', component: StaticContentComponent, pathMatch: 'full', data: { breadcrumb: 'Terms & Conditions' } },
      { path: 'faqs', component: FaqsComponent, pathMatch: 'full', data: { breadcrumb: 'FAQs' } },
      {
        path: 'scoring-system',
        loadComponent: () => import('./pages/others/scoring-system/scoring-system.component').then((m) => m.ScoringSystemComponent),
        pathMatch: 'full',
        data: { breadcrumb: 'Scoring System' },
      },
      {
        path: 'user/:active/:id',
        loadComponent: () => import('./pages/open-search/user-details/user-details.component').then((m) => m.UserDetailsComponent),
        canActivate: [authGuard],
        pathMatch: 'full',
        data: { breadcrumb: 'User Profile' },
      },
    ],
  },
  {
    path: 'featureFeed',
    component: ContentLayoutComponent,
    children: [
      { path: '', loadComponent: () => import('./pages/featureList/featureList.component').then((m) => m.FeaturedListComponent), pathMatch: 'full' },
    ],
    data: { breadcrumb: 'Featured Feeds' },
  },
  {
    path: 'search',
    canActivate: [authGuard],
    component: ContentLayoutComponent,
    children: [
      { path: '', loadComponent: () => import('./pages/open-search/open-search.component').then((m) => m.OpenSearchComponent), pathMatch: 'full' },
    ],
    data: { breadcrumb: 'Search Results' },
  },
  {
    path: '**',
    component: ContentLayoutComponent,
    children: [
      {
        path: '',
        component: NotFoundComponent,
      },
    ],
  },
];
